import { apiCall } from "@/common/api/ApiResult.model";
import { ListResult } from "@/common/models";
import {
  CognniCsvReport,
  CsvReportInput,
  CognniCsvReportHelper,
  CsvReportScheduleInput,
  CsvScheduleItem,
} from "./model";
import axios from "axios";
import { DownloadService } from "@/common/download.service";

//  res.data.map(CognniCsvReportHelper.from_api_item)
export const load_all_csv_reports = apiCall<
  { cursor: string },
  ListResult<CognniCsvReport>
>("csv-reports.get_all", async ({ cursor }) => {
  const res = await axios.get("/v2/report");
  return {
    success: true,
    value: {
      objects: res.data.map(CognniCsvReportHelper.from_api_item),
      cursor: "",
    },
  };
});

export const load_some_csv_reports = apiCall<
  string[],
  ListResult<CognniCsvReport>
>("csv-reports.get_some", async (ids) => {
  const res = await axios.get(
    "/v2/report?" + ids.map((id) => `ids=${id}`).join("&")
  );
  return {
    success: true,
    value: {
      objects: res.data.map(CognniCsvReportHelper.from_api_item),
      cursor: "",
    },
  };
});

export const delete_report = apiCall<string, boolean>(
  "csv-reports.delete",
  async (report_id) => {
    await axios.delete(`/v2/report/job/${report_id}`);
    return {
      success: true,
      value: true,
    };
  }
);

/**
 *  will return the url for the csv report to download it
 *  and an id for the report so that we can use it to delete it.
 * */
export const download_csv_report = apiCall<
  { report_name: string; report_id: string },
  { url: string; id: string }
>("csv-reports.download", async ({ report_id, report_name }) => {
  const res = await axios.get(`/v2/report/download/job/${report_id}`);
  const [, download] = DownloadService.from_web.zip({
    authorization: "",
    fileName: report_name + ".zip",
    filePath: res.data.url,
  });
  await download();
  // revoke url
  axios.delete(`v2/report/download/job/${res.data.id}`);
  return {
    success: true,
    value: res.data,
  };
});

export const create_csv_report = apiCall<CsvReportInput, boolean>(
  "csv-reports.generate",
  async (input) => {
    const res = await axios.post("/v2/report/intelligence", input);
    return {
      success: true,
      value: res.data,
    };
  }
);

// CsvReportScheduleInput
export const get_csv_report_schedule_items = apiCall<void, CsvScheduleItem[]>(
  "csv-reports-schedule.get_all",
  async () => {
    const res = await axios.get("/csv-report-scheduler");
    return {
      success: true,
      value: res.data.rules,
    };
  }
);

export const schedule_csv_report = apiCall<CsvReportScheduleInput, boolean>(
  "csv-reports-schedule.create",
  async (input) => {
    const res = await axios.post("/csv-report-scheduler", input);
    return {
      success: true,
      value: res.data,
    };
  }
);

export const update_csv_report_schedule = apiCall<
  { ruleId: string; subscribers?: string[]; timeFrame: "weekly" | "monthly" },
  boolean
>("csv-reports-schedule.update", async ({ timeFrame, subscribers, ruleId }) => {
  await axios.put("/csv-report-scheduler/" + ruleId, {
    timeFrame,
    subscribers,
  });
  return {
    success: true,
    value: true,
  };
});

export const remove_csv_report_schedule = apiCall<string, boolean>(
  "csv-reports-schedule.delete",
  async (rule_id) => {
    await axios.delete("/csv-report-scheduler/" + rule_id);
    return {
      success: true,
      value: true,
    };
  }
);
